// hooks/useScrambleProgress.ts
import { Alg } from "cubing/alg";
import { CubeCtx } from "../components/BluetoothCubeProvider";
import { StackmatState } from "../components/services/ICubingService";
import {
  parseMove,
  simplify,
  commonPrefixLen,
  AxisTurn,
} from "../components/utils/moveMath";
import { useContext, useEffect, useRef, useState } from "react";

export function useScrambleProgress(scramble: string) {

  const { selectService, getService, serviceType } = useContext(CubeCtx);
  const [state, setState] = useState<StackmatState | null>(null);
  const [isRunning, setRunning] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const service = getService(); // now kept inside the component function

  useEffect(() => {
      if (!service) return;

      let cancelled = false;

      const run = async () => {
          const alg = new Alg(new Alg());
          const isValid = await service.validateFacelets(alg);

          if (cancelled) return;

          if (isValid) {
              service.setReady(alg);
              setState(service.getCurrentState());
          } else {
              alert("Cube state does not match scramble. Please reset to a solved state.");
              run();
          }

          service.setCallback((newState: React.SetStateAction<StackmatState | null>) => {
              if (!cancelled) setState(newState);
          });
      };

      run();

      return () => {
          cancelled = true;
          service.setCallback(() => { });
          setRunning(false);
      };
  }, [serviceType, scramble]);

  const target = scramble
    .trim()
    .split(/\s+/)
    .map(parseMove)
    .filter(<T,>(x: T): x is NonNullable<T> => x !== null);


  const movesRef = useRef<AxisTurn[]>([]);   // all moves so far
  const [index, setIndex] = useState(0);

  // reset when scramble changes
  useEffect(() => {
    movesRef.current = [];
    setIndex(0);
  }, [scramble]);

  // useEffect(
  //   () =>
  //     addMoveListener((ev) => {
  //       if (ev.type !== "MOVE") return;
  //       const mv = parseMove(ev.move);
  //       if (!mv) return;                     // ignore rotations, slices, …

  //       movesRef.current.push(mv);

  //       const simplified = simplify(movesRef.current);
  //       movesRef.current = simplified;      // keep it slim

  //       setIndex(commonPrefixLen(simplified, target));
  //     }),
  //   [addMoveListener, target]
  // );

  return index; // can go up or down
}
